module.exports = __webpack_public_path__ + "fonts/BioRhyme-Regular.e01e7335.ttf";